export default __webpack_public_path__ + "static/media/FlotaMarina_Icon.fec45b6d.svg";